
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * OrderStatus enum
 */
class OrderStatus {
  /**
   * Initialize enum with a given value
   * @param {OrderStatus|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof OrderStatus) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!OrderStatus}
   * @param {!OrderStatus} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof OrderStatus)) {
      throw new TypeError('Instance of OrderStatus is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!OrderStatus}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!OrderStatus}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === OrderStatus.INVALID.value) {
      return 'INVALID'
    }
    if (this.value === OrderStatus.CREATED.value) {
      return 'CREATED'
    }
    if (this.value === OrderStatus.PENDING.value) {
      return 'PENDING'
    }
    if (this.value === OrderStatus.CANCELED.value) {
      return 'CANCELED'
    }
    if (this.value === OrderStatus.EXPIRED.value) {
      return 'EXPIRED'
    }
    if (this.value === OrderStatus.FILLED.value) {
      return 'FILLED'
    }
    if (this.value === OrderStatus.FILLED_PARTIALLY.value) {
      return 'FILLED_PARTIALLY'
    }
    if (this.value === OrderStatus.REJECTED.value) {
      return 'REJECTED'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!OrderStatus}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!OrderStatus}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!OrderStatus} Created enum
   */
  static fromObject (other) {
    return new OrderStatus(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
OrderStatus.INVALID = new OrderStatus(0 + 0)
// noinspection PointlessArithmeticExpressionJS
OrderStatus.CREATED = new OrderStatus(0 + 1)
// noinspection PointlessArithmeticExpressionJS
OrderStatus.PENDING = new OrderStatus(3 + 0)
// noinspection PointlessArithmeticExpressionJS
OrderStatus.CANCELED = new OrderStatus(5 + 0)
// noinspection PointlessArithmeticExpressionJS
OrderStatus.EXPIRED = new OrderStatus(5 + 1)
// noinspection PointlessArithmeticExpressionJS
OrderStatus.FILLED = new OrderStatus(5 + 2)
// noinspection PointlessArithmeticExpressionJS
OrderStatus.FILLED_PARTIALLY = new OrderStatus(5 + 3)
// noinspection PointlessArithmeticExpressionJS
OrderStatus.REJECTED = new OrderStatus(5 + 4)

export { OrderStatus };

/**
 * Fast Binary Encoding OrderStatus field model
 */
class FieldModelOrderStatus extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelOrderStatus}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelOrderStatus}
   * @param {OrderStatus=} defaults Default value, defaults is new OrderStatus()
   * @returns {!OrderStatus} Result value
   */
  get (defaults = new OrderStatus()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new OrderStatus(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelOrderStatus}
   * @param {!OrderStatus} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelOrderStatus };
